import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StateService {

    private accountNumber: string;

    constructor() {}

    setAccountNumber(accountNum: string) {
        this.accountNumber = accountNum;
    }
    getAccountNumber() {
        return this.accountNumber;
    }
} 